import { Chart as C, ChartConfiguration } from "chart.js";
import { useEffect, useRef } from "react";

export const Chart = ({
  type,
  className = "",
  ...config
}: ChartConfiguration & {
  className?: string;
  responsive?: boolean;
  maintainAspectRatio?: boolean;
}) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const chartRef = useRef<C | null>(null);

  // Create chart once on mount
  useEffect(() => {
    if (!canvasRef.current) return;
    chartRef.current = new C(canvasRef.current, { type, ...config });
    return () => {
      chartRef.current?.destroy();
      chartRef.current = null;
    };
  }, []);

  // Update chart data/options on changes
  useEffect(() => {
    if (!chartRef.current) return;
    if (config.data) {
      chartRef.current.data = config.data;
    }
    if (config.options) {
      chartRef.current.options = { ...chartRef.current.options, ...config.options };
    }
    chartRef.current.update();
  }, [config.data, config.options]);

  return (
    <div>
      <canvas className={className} ref={canvasRef} />
    </div>
  );
};
